import React, { useState, useContext } from "react";
import HeaderBar from "../../components/HeaderBar";
import getCurrentSkin from "../../utils/getCurrentSkin";
import { ThemeContext } from "../../context/ThemeContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaChevronDown, FaChevronUp, FaSave, FaUndo, FaArrowLeft, FaUpload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PayRollLayoutWrapper from "../../components/PayRollLayoutWrapper";

const AdvanceEntry = () => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    empCode: "",
    empName: "",
    designation: "",
    salary: "",
    prevBalance: "",
    advance: "",
    totalAdvance: "",
    site: "HEAD-OFFICE",
    department: "",
    salaryMonth: "",
    date: "",
    repaymentMode: "",
    file: null,
  });

  const [showForm, setShowForm] = useState(true);

  const inputClass = `w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
    isDark
      ? "bg-gray-700/30 border-gray-600 text-white"
      : "bg-white border-gray-300 text-gray-900"
  }`;

  const labelClass = `block text-sm font-medium mb-2 ${
    isDark ? "text-gray-300" : "text-gray-700"
  }`;

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSave = () => {
    // Validate required fields
    const requiredFields = [
      'empCode', 'empName', 'designation', 'salary', 
      'prevBalance', 'advance', 'site', 'department', 
      'salaryMonth', 'date'
    ];
    
    const missingFields = requiredFields.filter(field => !formData[field]);
    
    if (missingFields.length > 0) {
      toast.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
      return;
    }
    
    console.log("Form Submitted:", formData);
    toast.success("Advance Entry Saved Successfully!");
    navigate("/PayRoll/AdvanceListing");
  };

  const handleReset = () => {
    setFormData({
      empCode: "",
      empName: "",
      designation: "",
      salary: "",
      prevBalance: "",
      advance: "",
      totalAdvance: "",
      site: "HEAD-OFFICE",
      department: "",
      salaryMonth: "",
      date: "",
      repaymentMode: "",
      file: null,
    });
    toast.info("Form has been reset");
  };

  const handleBack = () => {
    navigate("/PayRoll/AdvanceListing");
  };

  return (
    <PayRollLayoutWrapper>
      <div className={`min-h-screen p-6 ${isDark ? "bg-gray-900" : "bg-gray-100"}`}>
        <HeaderBar
          title={<span className="font-dmserif text-3xl">ADVANCE ENTRY</span>}
          setSkin={setSkin}
          currentSkin={skin}
        />
  <button
                onClick={handleBack}
              className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-xl border transition ${
            isDark
              ? "border-slate-600 text-slate-300 hover:bg-slate-800"
              : "border-slate-300 text-slate-700 hover:bg-slate-100"
          }`}
              >
                <FaArrowLeft />
                Back
              </button>
        <div className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white text-black`
        }`}>
          {/* Header Section */}
          <div className="flex justify-between items-center mb-8">
            <div className="flex items-center gap-4">
              <h1 className={`text-2xl font-bold ${
                isDark ? "text-white" : "text-gray-900"
              }`}>
                Advance Entry Form
              </h1>
              <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                isDark 
                  ? "bg-blue-900 text-blue-100" 
                  : "bg-blue-100 text-blue-800"
              }`}>
                New Entry
              </span>
            </div>
            
            <div className="flex items-center gap-3">
              {/* Hide/Show Form Button */}
              <button
                onClick={() => setShowForm(!showForm)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${
                  isDark 
                    ? "bg-gray-700 hover:bg-gray-600 text-white border border-gray-600" 
                    : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300"
                }`}
              >
                {showForm ? <FaChevronUp /> : <FaChevronDown />}
                {showForm ? "Hide Form" : "Show Form"}
              </button>

            
            </div>
          </div>

          {/* Collapsible Form Section */}
          <div className={`rounded-xl border mb-6 overflow-hidden transition-all duration-300 ${
            isDark 
              ? "border-gray-700" 
              : "border-gray-200"
          }`}>
            {/* Form Header - Always Visible */}
            <div 
              className={`p-4 cursor-pointer transition-colors duration-200 ${
                isDark 
                  ? "bg-gray-800 hover:bg-gray-750" 
                  : "bg-gray-50 hover:bg-gray-100"
              }`}
              onClick={() => setShowForm(!showForm)}
            >
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold flex items-center gap-2">
                  ADVANCE ENTRY DETAILS
                </h3>
                <div className="flex items-center gap-3">
                  <span className={`text-sm ${
                    isDark ? "text-gray-400" : "text-gray-600"
                  }`}>
                    Click to {showForm ? 'hide' : 'show'} form
                  </span>
                  {showForm ? (
                    <FaChevronUp className="text-lg" />
                  ) : (
                    <FaChevronDown className="text-lg" />
                  )}
                </div>
              </div>
            </div>

            {/* Form Content - Collapsible */}
            <div className={`transition-all duration-300 ease-in-out ${
              showForm 
                ? 'max-h-screen opacity-100' 
                : 'max-h-0 opacity-0 overflow-hidden'
            }`}>
              <div className={`p-6 border-t ${
                isDark 
                  ? "bg-gray-800 border-gray-700" 
                  : "bg-gray-50 border-gray-200"
              }`}>
                <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Left Column */}
                  <div className="space-y-4">
                    {/* Employee Code */}
                    <div>
                      <label className={labelClass}>
                        Employee Code <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="empCode"
                        value={formData.empCode}
                        onChange={handleChange}
                        className={inputClass}
                        placeholder="Enter employee code"
                      />
                    </div>

                    {/* Employee Name */}
                    <div>
                      <label className={labelClass}>
                        Employee Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="empName"
                        value={formData.empName}
                        onChange={handleChange}
                        className={inputClass}
                        placeholder="Enter employee name"
                      />
                    </div>

                    {/* Designation */}
                    <div>
                      <label className={labelClass}>
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="designation"
                        value={formData.designation}
                        onChange={handleChange}
                        className={inputClass}
                      >
                        <option value="">Select</option>
                        <option value="Manager">Manager</option>
                        <option value="Engineer">Engineer</option>
                        <option value="Clerk">Clerk</option>
                      </select>
                    </div>

                    {/* Salary */}
                    <div>
                      <label className={labelClass}>
                        Salary <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        name="salary"
                        value={formData.salary}
                        onChange={handleChange}
                        className={inputClass}
                        placeholder="Enter salary amount"
                      />
                    </div>

                    {/* Previous Balance */}
                    <div>
                      <label className={labelClass}>
                        Previous Balance <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        name="prevBalance"
                        value={formData.prevBalance}
                        onChange={handleChange}
                        className={inputClass}
                        placeholder="Enter previous balance"
                      />
                    </div>

                    {/* Advance */}
                    <div>
                      <label className={labelClass}>
                        Advance <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        name="advance"
                        value={formData.advance}
                        onChange={handleChange}
                        className={inputClass}
                        placeholder="Enter advance amount"
                      />
                    </div>

                    {/* Total Advance */}
                    <div>
                      <label className={labelClass}>Total Advance</label>
                      <input
                        type="number"
                        name="totalAdvance"
                        value={formData.totalAdvance}
                        onChange={handleChange}
                        className={inputClass}
                        placeholder="Total advance amount"
                      />
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="space-y-4">
                    {/* Site Name */}
                    <div>
                      <label className={labelClass}>
                        Site Name <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="site"
                        value={formData.site}
                        onChange={handleChange}
                        className={inputClass}
                      >
                        <option value="HEAD-OFFICE">HEAD-OFFICE</option>
                        <option value="HILARA">HILARA</option>
                      </select>
                    </div>

                    {/* Department */}
                    <div>
                      <label className={labelClass}>
                        Department <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="department"
                        value={formData.department}
                        onChange={handleChange}
                        className={inputClass}
                      >
                        <option value="">Select</option>
                        <option value="Finance">Finance</option>
                        <option value="HR">HR</option>
                        <option value="IT">IT</option>
                      </select>
                    </div>

                    {/* Salary Month */}
                    <div>
                      <label className={labelClass}>
                        Salary Month <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="salaryMonth"
                        value={formData.salaryMonth}
                        onChange={handleChange}
                        className={inputClass}
                      >
                        <option value="">Select</option>
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                      </select>
                    </div>

                    {/* Date */}
                    <div>
                      <label className={labelClass}>
                        Date <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        className={inputClass}
                      />
                    </div>

                    {/* Repayment Mode */}
                    <div>
                      <label className={labelClass}>Repayment Mode</label>
                      <select
                        name="repaymentMode"
                        value={formData.repaymentMode}
                        onChange={handleChange}
                        className={inputClass}
                      >
                        <option value="">Select</option>
                        <option value="Cash">Cash</option>
                        <option value="Bank Transfer">Bank Transfer</option>
                        <option value="Deduction from Salary">Deduction from Salary</option>
                      </select>
                    </div>

                    {/* File Upload */}
                    <div>
                      <label className={labelClass}>File Attachment</label>
                      <div className={`flex items-center ${inputClass} p-0 overflow-hidden`}>
                        <label className={`px-3 py-2 cursor-pointer ${
                          isDark ? "bg-gray-700 text-white" : "bg-gray-200 text-gray-700"
                        }`}>
                          <FaUpload className="inline mr-2" />
                          Choose File
                          <input
                            type="file"
                            name="file"
                            onChange={handleChange}
                            className="hidden"
                          />
                        </label>
                        <span className={`px-3 text-sm ${
                          isDark ? "text-gray-400" : "text-gray-600"
                        }`}>
                          {formData.file ? formData.file.name : "No file chosen"}
                        </span>
                      </div>
                    </div>
                  </div>
                </form>

                {/* Action Buttons */}
                <div className="flex gap-4 mt-8 pt-6 justify-end border-t border-gray-200 dark:border-gray-700">
                  <button
                    onClick={handleSave}
                    className={`flex items-center gap-2 ${buttonClass} ${hoverClass} text-white px-6 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200`}
                  >
                    <FaSave />
                    Save
                  </button>
                  <button
                    onClick={handleReset}
                    className={`flex items-center gap-2 px-6 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${
                      isDark 
                        ? "bg-red-700 hover:bg-red-600 text-white" 
                        : "bg-red-600 hover:bg-red-700 text-white"
                    }`}
                  >
                    <FaUndo />
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            theme={isDark ? "dark" : "light"}
          />
        </div>
      </div>
    </PayRollLayoutWrapper>
  );
};

export default AdvanceEntry;